import React from 'react';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';
import { useToast, Toast as ToastType } from '../contexts/ToastContext';

const Toast: React.FC<{ toast: ToastType }> = ({ toast }) => {
  const { removeToast } = useToast();

  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return <CheckCircle className="h-5 w-5 text-[#2AB7A6] dark:!text-[#2AB7A6]" />;
      case 'error':
        return <AlertCircle className="h-5 w-5 text-red-500 dark:!text-red-400" />;
      case 'warning':
        return <AlertTriangle className="h-5 w-5 text-yellow-500 dark:!text-yellow-400" />;
      case 'info':
        return <Info className="h-5 w-5 text-blue-500 dark:!text-blue-400" />;
      case 'buy':
        return <CheckCircle className="h-5 w-5 text-green-500 dark:!text-green-400" />;
      case 'sell':
        return <CheckCircle className="h-5 w-5 text-red-500 dark:!text-red-400" />;
      default:
        return <Info className="h-5 w-5 text-blue-500 dark:!text-blue-400" />;
    }
  };

  const getBgColor = () => {
    switch (toast.type) {
      case 'success':
        return 'bg-[#2AB7A6]/10 dark:!bg-[#1f2937] border-[#2AB7A6]/20 dark:!border-[#6b7280]';
      case 'error':
        return 'bg-red-50 dark:!bg-[#1f2937] border-red-200 dark:!border-[#6b7280]';
      case 'warning':
        return 'bg-yellow-50 dark:!bg-[#1f2937] border-yellow-200 dark:!border-[#6b7280]';
      case 'info':
        return 'bg-blue-50 dark:!bg-[#1f2937] border-blue-200 dark:!border-[#6b7280]';
      case 'buy':
        return 'bg-green-50 dark:!bg-[#1f2937] border-green-200 dark:!border-[#6b7280]';
      case 'sell':
        return 'bg-red-50 dark:!bg-[#1f2937] border-red-200 dark:!border-[#6b7280]';
      default:
        return 'bg-blue-50 dark:!bg-[#1f2937] border-blue-200 dark:!border-[#6b7280]';
    }
  };

  const getTextColor = () => {
    switch (toast.type) {
      case 'success':
        return 'text-[#2AB7A6] dark:!text-[#f9fafb]';
      case 'error':
        return 'text-red-800 dark:!text-[#f9fafb]';
      case 'warning':
        return 'text-yellow-800 dark:!text-[#f9fafb]';
      case 'info':
        return 'text-blue-800 dark:!text-[#f9fafb]';
      case 'buy':
        return 'text-green-800 dark:!text-[#f9fafb]';
      case 'sell':
        return 'text-red-800 dark:!text-[#f9fafb]';
      default:
        return 'text-blue-800 dark:!text-[#f9fafb]';
    }
  };

  return (
    <div
      className={`flex items-center p-2 rounded-lg border shadow-lg max-w-sm w-full ${getBgColor()} ${getTextColor()} transition-all duration-300 ease-in-out transform translate-x-0 opacity-100`}
      style={{
        animation: 'slideInRight 0.3s ease-out'
      }}
    >
      <div className="flex-shrink-0 mr-3">
        {getIcon()}
      </div>
      <div className="flex-1 text-xs font-medium">
        {toast.message}
      </div>
      <button
        onClick={() => removeToast(toast.id)}
        className="flex-shrink-0 ml-3 text-gray-400 hover:text-gray-600 dark:!text-[#6b7280] dark:hover:!text-[#e5e7eb] transition-colors duration-200"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default Toast;
